var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "relatedEventsModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        "pivot-y": 0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "modal-padding" }, [
        _c(
          "div",
          { staticClass: "manage-related-events-container margin-side" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6 page-title h2-text" }, [
                _vm._v("Manage Related Events")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6 noPaddingRight align-right-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-close-img",
                      on: { click: _vm.hideModal }
                    },
                    [_c("div", { staticClass: "icon-close" })]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.eventId
              ? _c("ManageRelatedEvents", {
                  attrs: {
                    relatedEvents: _vm.relatedEvents,
                    currentEvent: _vm.currentEvent,
                    eventId: _vm.eventId
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6623d6ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6623d6ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/event/RelatedEventsModal.vue
// module id = 1669
// module chunks = 1